import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import { Header } from "./components/header"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { useMemo } from "react"
import { PageTopBar, TwoSlotLayout } from "../../../../../common/components/page_top_bar"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { Link as LinkTo } from "react-router"
import { BackButton } from "../../../../../common/components/back_button"
import { CadastroChecklistServicoLiberacaoModal } from "./components/cadastro_checklist_liberacao_modal"
import { CopiaChecklistServicoLiberacaoModal } from "./components/copia_checklist_entrega_liberacao_modal"
import { useChecklistServicoLiberacaoListaViewModel } from "../../viewModels/checklist_servico_lista_liberacao_view_model"
import { GenerateChecklistServicoLiberacaoColumns } from "./columns"
import { ChecklistServicoLiberacao } from "../../../domain/models/checklist_servico_liberacao"

import RefreshButton from "../../../../../common/components/refresh_button"
import AlertError from "../../../../../common/components/alert_error"
import DeleteDialog from "../../../../../common/components/delete_dialog"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"

export const ChecklistServicoLiberacaoLista = () => {
  const viewModel = useChecklistServicoLiberacaoListaViewModel();

  const columnsDef = useMemo(() => {
    return GenerateChecklistServicoLiberacaoColumns({
      hasObraChecklistServico: false /*viewModel.selectedChecklistServico !== undefined && viewModel.selectedChecklistServico.hasObraChecklistServico*/,
      onActionEdit: viewModel.handleChecklistServicoLiberacaoOpenState,
      onActionDelete: viewModel.handleChecklistServicoLiberacaoDeleteOpenState,
      onActionCopia: viewModel.handleChecklistServicoLiberacaoCopiaOpenState,
    });
  }, [
    viewModel.handleChecklistServicoLiberacaoOpenState,
    viewModel.handleChecklistServicoLiberacaoDeleteOpenState,
    viewModel.handleChecklistServicoLiberacaoCopiaOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <TwoSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 ">
              <div className="w-[175px] ">
                {/*
                  !(viewModel.selectedChecklistServico !== undefined
                    && viewModel.selectedChecklistServico.hasObraChecklistServico) &&
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                    onClick={() => viewModel.handleChecklistServicoLiberacaoOpenState(null, true)}>
                    Novo Checklist
                  </PrimaryButton>
                */}
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleChecklistServicoLiberacaoOpenState(null, true)}>
                  Novo Checklist
                </PrimaryButton>
              </div>

              <div>
                <BackButton onClick={viewModel.handleBack} />
              </div>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-6 flex-col py-5 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Home
          </Link>
          <Link underline="hover" color="inherit" component={"span"}>
            <LinkTo to="/ChecklistServico_lista">Checklist de Serviço</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Liberação Checklist de Servico
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Liberação Checklist de Serviço</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>

          <div className="flex gap-2 items-center w-full">
            {/* iNFORMAÇÕES DO CHECKLIST DE SERVIÇO SELECIONADO */}
            {
              viewModel.selectedChecklistServico &&
              <div className="w-full flex flex-col gap-0">
                <div className="w-full flex flex-row items-center">
                  <span className="text-black dark:text-white font-bold text-lg">
                    {viewModel.selectedChecklistServico.codigo} | {viewModel.selectedChecklistServico.descricao}
                  </span>
                </div>
                <div> </div>
                {
                  (viewModel.selectedChecklistServico.revisao && viewModel.selectedChecklistServico.revisao.length > 0) &&
                  <span className="text-gray-600 dark:text-gray-300 font-bold text-base">
                    Revisão: {viewModel.selectedChecklistServico.revisao}
                  </span>
                }
                {/*
                  viewModel.selectedChecklistServico.hasObraChecklistServico &&
                  <div className="w-full mt-4">
                    <Alert severity="error">
                      Não é possível incluir ou excluir ambientes do check list, pois ele está vinculado à alguma obra.
                    </Alert>
                  </div>
                */}
              </div>
            }
          </div>
        </div>
        {
          viewModel.errorMessage !== undefined ? (
            <div className="w-full">
              <AlertError
                messageErro={viewModel.errorMessage}
                onTryAgain={viewModel.handleReload} />
            </div>
          ) : (
            <>
              <Header
                descricao={viewModel.filters.descricao}
                handleDescricaoChange={viewModel.handleDescricaoChange}
                onClearFilters={viewModel.handleClearFilters}
              />

              <Stack spacing={0}>
                <div className="w-full flex flex-row justify-between items-stretch">
                  <div className="flex flex-col justify-between flex-1">
                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                  </div>
                </div>

                <StyledDataGrid
                  tableName="liberacao_checklist_servico"
                  disableColumnMenu={false}
                  showToolbar={true}
                  disableRowSelectionOnClick={true}
                  getRowId={(row: ChecklistServicoLiberacao) => row.idChecklistServicoLiberacao}
                  getRowHeight={() => 'auto'}
                  columns={columnsDef}
                  loading={viewModel.loading}
                  checkboxSelection={false}
                  rows={viewModel.checklistServicoLiberacaoLista}
                  rowCount={viewModel.checklistServicoLiberacaoLista.length}
                  pageSizeOptions={[10, 25, 50, 100]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.pagination.page,
                    pageSize: viewModel.pagination.rowsPerPage,
                  }}
                  pinnedColumns={{
                    right: viewModel.checklistServicoLiberacaoLista.length > 0
                      ? ['idChecklistServicoLiberacao', 'acoes']
                      : [],
                  }}
                />

                <TablePagination
                  component="div"
                  count={viewModel.pagination.totalItems}
                  page={viewModel.pagination.page - 1}
                  onPageChange={(_, p) => viewModel.handlePageChange(p)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 25}
                  onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                />
              </Stack>


            </>
          )
        }
      </div >

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.handleChecklistServicoLiberacaoDeleteOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleConfirmarDeletarChecklistServicoLiberacao}
      />

      <CadastroChecklistServicoLiberacaoModal
        open={viewModel.openCadastroModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedChecklistServicoLiberacao={viewModel.selectedChecklistServicoLiberacao}
        onClose={() => viewModel.handleChecklistServicoLiberacaoOpenState(null, false)}
        onSubmit={viewModel.handleSubmitChecklistServicoLiberacao}
        onOpenChangeHistory={viewModel.handleOpenChangeHistory}
      />

      <CopiaChecklistServicoLiberacaoModal
        open={viewModel.openCopiaModal}
        saving={viewModel.saving}
        selectedChecklistServicoLiberacao={viewModel.selectedChecklistServicoLiberacao}
        onClose={() => viewModel.handleChecklistServicoLiberacaoCopiaOpenState(null, false)}
        onSubmit={viewModel.handleSubmitChecklistServicoLiberacaoCopia}
      />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

    </>
  )
}


